import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IDateDurationExpressionBehavior } from "../../../../documaker/domain/format/objects";

export interface IDateDurationExpressionBehaviorPropertyEditable {
  dateDurationExpressionBehavior(): IPropertyEditable<IDateDurationExpressionBehavior>;
}

export function instanceOfIDateDurationExpressionBehaviorPropertyEditable(instance: any): instance is IDateDurationExpressionBehaviorPropertyEditable {
  return instance
      && instance.dateDurationExpressionBehavior
      && instanceOfIPropertyEditable<IDateDurationExpressionBehavior>(instance.dateDurationExpressionBehavior());
}
